import { get, post } from '../lib/apiClient';

/** POST /auth/login — { username|email, password } → TokenPair + user */
export const login = (credentials) => post('/auth/login', credentials, { auth: false });

/** POST /auth/logout */
export const logout = () => post('/auth/logout');

/** POST /auth/refresh — explicit refresh (apiClient also does this transparently) */
export const refresh = (refreshToken) =>
  post('/auth/refresh', { refreshToken }, { auth: false });

// ---- OAuth ----

/**
 * GET /auth/oauth/{provider} — returns { authorizationUrl } to redirect the
 * browser to. 400 if the provider has no credentials configured server-side.
 */
export const oauthInitiate = (provider) =>
  get(`/auth/oauth/${encodeURIComponent(provider)}`, { auth: false });

/**
 * GET /auth/oauth/callback/{provider}?code&state — completes the flow the
 * provider redirected back from; returns TokenPair + user. The state is
 * single-use and PKCE-validated server-side.
 */
export const oauthCallback = (provider, { code, state }) =>
  get(`/auth/oauth/callback/${encodeURIComponent(provider)}`, {
    query: { code, state },
    auth: false
  });

// ---- MFA (FEA-04) ----

/** POST /auth/mfa/setup — start enrollment; returns { secret, otpauthUri } */
export const mfaSetup = () => post('/auth/mfa/setup');

/**
 * POST /auth/mfa/verify-setup — prove possession; returns
 * { mfaEnabled, recoveryCodes } (codes are shown exactly once).
 */
export const mfaVerifySetup = (code) => post('/auth/mfa/verify-setup', { code });

/**
 * POST /auth/mfa/challenge — exchange the login-issued mfaToken plus a TOTP
 * code or an unused recovery code for the real TokenPair + user.
 */
export const mfaChallenge = (mfaToken, { code, recoveryCode }) =>
  post('/auth/mfa/challenge', { mfaToken, code, recoveryCode }, { auth: false });

/** POST /auth/mfa/disable — requires a current TOTP code or recovery code */
export const mfaDisable = ({ code, recoveryCode }) =>
  post('/auth/mfa/disable', { code, recoveryCode });

/** POST /auth/org-exchange — exchange current token for one scoped to a different org (MTN §12.3) */
export const orgExchange = (orgId) =>
  post('/auth/org-exchange', { orgId });
